<template>
    <div class="video-box">
      <div class="imgPosterH" v-if="isProgram=='programs' && imgUrl" >
        <img :src="imgUrl" style="object-fit: contain; width: 100%; height: 100%;">
      </div>
      <div v-else-if="isProgram=='program' && videoPath" class="demo1-video">
        <video  id="myVideo" class="video-js vjs-default-skin vjs-16-9 vjs-big-play-centered"
          preload="none"
          width="100%"
          height="237"
          ref="vueMiniPlayer"
          @error="myScript"
          :poster="imgUrl">
          <source :src="videoPath" :type="videoType"/>
        </video>
      </div>
      <img v-else-if="isProgram=='program' && !videoPath" :src="imgUrl" @click="messageShow" class="img">
      <img v-else class="img" src="../assets/img_cover.png">
      <div class="errorTips" v-if="isError">
        <p class="tips">无法加载媒体，可能是因为服务器或网络发生故障，或者是因为不支持该格式</p>
      </div>
    </div>

</template>
<script>
export default {
  name: 'Video',
  props: ['imgUrl', 'isProgram', 'videoPath'],
  data () {
    return {
      // videoSrc: 'http://vodkgeyttp8.vod.126.net/cloudmusic/mv/20171019022414/5eada42b-f138-4f57-b93a-434fee85b048/f99a73831924ecfda5368e09f74e05f9.mp4?wsSecret=d44c8f0fd798b5e472f86eb801a908aa&wsTime=1604906751',
      videoType: 'video/mp4', // 视频类型
      isError: false
    }
  },
  mounted () {
    if (this.isProgram == 'program') {
      this.initVideo()
    }
  },
  methods: {
    myScript () {
      this.isError = true
    },
    initVideo () {
      // 初始化视频方法
      this.$video(document.getElementById('myVideo'), {
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        // 自动播放属性,muted:静音播放
        autoplay: false,
        // 建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: 'none',
        // 设置视频播放器的显示宽度（以像素为单位）
        width: '100%',
        // 设置视频播放器的显示高度（以像素为单位）
        height: '237px',
        // 错误提示展示
        errorDisplay: false
      })
    },
    pause () {
      this.$refs.vueMiniPlayer.pause()
    },
    messageShow () {
      this.$message.warning('没有介质!')
    }
  }
}
</script>

<style scoped lang="less">
  .img {
    display: block;
    width: 100%;
    height: 237px;
  }
  .video-box{
    position: relative;
    background-color:rgba(0,0,0,0.1);
    text-align: center;
  }
  .imgPosterH {
    width: 100%;
    height: 237px;
  }
  .errorTips {
    position: absolute;
    top:0;
    width: 100%;
    height:100%;
    background: rgba(0,0,0,0.5);
    .tips {
    color: #fff;
    font-size: 16px;
    text-align: center;
    padding: 10px;
    line-height: 1.5;
    }
  }
</style>
